/**
 * Web Component: collection-seo-content
 * Maneja la expansión/colapso accesible y el formateo de contenido SEO en colecciones.
 */
if (!customElements.get('collection-seo-content')) {
  customElements.define(
    'collection-seo-content',
    class CollectionSeoContent extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-seo-toggle]');
        this.body = this.querySelector('[data-seo-body]');
        this.card = this.querySelector('[data-seo-card]');
        this.textContainer = this.querySelector('[data-seo-text]');
        this.textMore = this.dataset.textMore || 'Ver más';
        this.textLess = this.dataset.textLess || 'Ver menos';
        this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 110;

        if (!this.body) return;

        this.formatMarkdownIfNeeded();
        if (this.button) {
          this.init();
        }
      }

      formatMarkdownIfNeeded() {
        if (!this.textContainer) return;
        const html = this.textContainer.innerHTML;
        // Si ya contiene etiquetas de bloque estructurado, respetar el HTML
        if (/<(p|h[1-6]|ul|ol|table|blockquote)[^>]*>/i.test(html)) {
          return;
        }

        const raw = this.textContainer.innerText || this.textContainer.textContent;
        const lines = raw.split(/\r?\n/);
        let formatted = '';
        let inList = false;

        for (let i = 0; i < lines.length; i++) {
          const line = lines[i].trim();
          if (!line) {
            if (inList) {
              formatted += '</ul>';
              inList = false;
            }
            continue;
          }

          if (line.startsWith('- ') || line.startsWith('• ') || line.startsWith('* ')) {
            if (!inList) {
              formatted += '<ul>';
              inList = true;
            }
            const item = line.replace(/^[-•*]\s+/, '');
            formatted += `<li>${item}</li>`;
          } else {
            if (inList) {
              formatted += '</ul>';
              inList = false;
            }
            if (line.startsWith('### ')) {
              formatted += `<h3>${line.substring(4)}</h3>`;
            } else if (line.startsWith('## ')) {
              formatted += `<h2>${line.substring(3)}</h2>`;
            } else if (line.startsWith('# ')) {
              formatted += `<h2>${line.substring(2)}</h2>`;
            } else {
              formatted += `<p>${line}</p>`;
            }
          }
        }
        if (inList) {
          formatted += '</ul>';
        }

        if (formatted.length > 0) {
          this.textContainer.innerHTML = formatted;
        }
      }

      init() {
        this.checkHeight();

        this.button.addEventListener('click', this.toggle.bind(this));

        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => this.checkHeight(), 150);
        });
      }

      checkHeight() {
        if (this.classList.contains('is-expanded')) return;

        requestAnimationFrame(() => {
          if (this.body.scrollHeight <= this.collapsedHeight + 25) {
            this.classList.add('no-collapse-needed');
            this.button.classList.add('hidden');
            this.body.style.maxHeight = 'none';
          } else {
            this.classList.remove('no-collapse-needed');
            this.button.classList.remove('hidden');
            this.body.style.maxHeight = `${this.collapsedHeight}px`;
          }
        });
      }

      toggle() {
        const isExpanded = this.classList.contains('is-expanded');
        const buttonText = this.querySelector('[data-seo-button-text]');

        if (isExpanded) {
          this.classList.remove('is-expanded');
          this.body.style.maxHeight = `${this.collapsedHeight}px`;
          this.button.setAttribute('aria-expanded', 'false');
          if (buttonText) buttonText.textContent = this.textMore;

          if (this.card) {
            const rect = this.card.getBoundingClientRect();
            if (rect.top < 80) {
              window.scrollTo({
                top: window.scrollY + rect.top - 100,
                behavior: 'smooth'
              });
            }
          }
        } else {
          this.classList.add('is-expanded');
          this.body.style.maxHeight = `${this.body.scrollHeight}px`;
          this.button.setAttribute('aria-expanded', 'true');
          if (buttonText) buttonText.textContent = this.textLess;
        }
      }
    }
  );
}
